import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { UpdateShipLine } from '../../_models/updateShipLine';
import { Globals } from '../../_models/globals';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-driver-assignment',
  templateUrl: './driver-assignment.component.html',
  styleUrls: ['./driver-assignment.component.css']
})
export class DriverAssignmentComponent implements OnInit {
  driversList: any;
  statusText1: string;
  errorMessage: string;
  statusText2: string;
  driverName: string;
  comments: string;
  shipLines: UpdateShipLine[] = [];
  shipLine: UpdateShipLine = {
    //shipLineId : ""
  };
  //  shipLines: Array<UpdateShipLine>;

  constructor(private alertService: AlertService, private api: ApiIntegration, private http: HttpClient, private router: Router, private g: Globals, private route: ActivatedRoute) {
    this.g.page = "Assignment";
    //    this.shipLines= [];
    this.api.getShiftDriversList("1", "ACTIVE").subscribe((data: any) => {
      this.driversList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }
  selectDriverName() {
    this.statusText1 = "";
    if (this.driverName == '' || this.driverName === null || this.driverName === undefined || this.driverName === 'undefined') {
      this.statusText1 = 'Please select Driver Name';
    }
  }
  typeComments() {
    this.statusText2 = "";
    if (this.comments == '' || this.comments === null || this.comments === undefined || this.comments === 'undefined') {
      this.statusText2 = 'Please enter Valid Comment';
    }
  }
  submitAssignment() {

    let shipLinesId = JSON.parse(this.route.snapshot.params['lineId']);
    shipLinesId.forEach((l) => {
      this.shipLine.shipLineId = l;
      this.shipLine.status = "ASSIGNED";
      this.shipLines.push(_.cloneDeep(this.shipLine));
    });

    this.statusText1 = "";
    this.statusText2 = "";

    if (this.driverName == '' || this.driverName === null || this.driverName === undefined || this.driverName === 'undefined') {
      this.statusText1 = 'Please select Driver Name';
    }

    if (this.comments == '' || this.comments === null || this.comments === undefined || this.comments === 'undefined') {
      this.statusText2 = 'Please enter Valid Comment';
    }

    if (this.statusText1 != "" || this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    //this.shipLines.status = "ASSIGNED" ;
    this.http.post(environment.apiUrl + 'api/updateShipmentStatus',
      {
        //"headerId":this.route.snapshot.params['headerId'],
        "notes": this.comments,
        "organizationId": 1,
        "shiftDriverId": this.driverName,
        //"status": "ASSIGNED",
        // "shipLineId": this.route.snapshot.params['lineId'],
        "updateShipLine": this.shipLines
      },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('DriverAssignment', 'Status Updated Successfully');

          this.router.navigate(['/admin/adminShipmentList']);
        } else {
          if (data['code'] == 400) {
            this.alertService.error('Error', data['message']);
          }
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
